const runtimeConfig = Object.freeze({
  /**
   * 是否作为低代码/宿主系统嵌入运行
   * false: 独立部署，构建输出到当前项目 dist
   * true:  嵌入模式，构建输出到后端静态目录
   */
  embedMode: false,

  /**
   * 登录方式
   * local: 本地登录页
   * sso:   统一认证中心
   */
  authMode: 'sso',

  /**
   * 本地登录时是否要求上传证书
   * true:  显示证书上传，并要求提交证书
   * false: 不显示证书上传
   */
  certRequired: true
});

export default runtimeConfig;
